import request from '../libs/request';

const res = 'FilterColumn';

export default {
  queryByDataViewID(dataViewID) {
    return request({
      url: `api/${res}/query`,
      method: 'post',
      data: {
        dataViewID,
        orderBy: '+OrderNo'
      }
    });
  }
};
